import { Injectable } from '@angular/core';
import { ROARR } from 'roarr';
import { Subject } from 'rxjs';
import { Log } from './log';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  log$ = new Subject<Log>();

  constructor() {
    ROARR.write = (message) => {
      const payload = JSON.parse(message) as Log;
      this.log$.next(payload);
    };
  }

}
